<script setup lang="ts">
import { mdiViewDashboardOutline } from "@mdi/js";
import { useScreenSize } from "@soft-db/ui";
import NavButton from "./NavButton.vue";

defineProps<{
	siteId?: string;
	disabled?: boolean;
	disabledReason?: string;
}>();

const { t } = useI18n();
const { mdOrLower } = useScreenSize();
</script>

<template>
	<NavButton
		:title="t('common.dashboard')"
		:icon="mdiViewDashboardOutline"
		:to="{
			name: 'dashboard-id',
			params: { id: siteId ?? '0' },
		}"
		color="primary"
		:disabled="disabled"
		:disabledReason="disabledReason"
		:size="mdOrLower ? 'lg' : 'sm'"
	/>
</template>
